import { useNavigate } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/hooks/use-auth';

import Button from '../common/Button';
import { buildProfileFields } from './profileFields';
import ProfileFieldsList from './ProfileFieldsList';

const CompleteProfileModalDesktop = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoToSettings = () => {
    navigate({ to: '/dashboard/settings', search: { tab: 'profile' } });
  };

  const fields = buildProfileFields(t, user);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
        className="w-full max-w-md rounded-2xl bg-surface-card p-8 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Warning Icon */}
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
            <AlertTriangle className="h-8 w-8 text-amber-600" />
          </div>
        </div>

        {/* Title and Subtitle */}
        <div className="mb-6 text-center">
          <h2 className="font-heading text-xl font-semibold text-foreground-primary">
            {t('profileCompletion.title')}
          </h2>
          <p className="mt-2 font-body text-sm text-foreground-secondary">
            {t('profileCompletion.subtitle')}
          </p>
        </div>

        {/* Explanation */}
        <p className="mb-4 font-body text-sm text-foreground-secondary">
          {t('profileCompletion.explanation')}
        </p>

        {/* Fields List */}
        <ProfileFieldsList fields={fields} isDesktop />

        {/* CTA Button */}
        <Button
          type="button"
          variant="solid"
          size="lg"
          onClick={handleGoToSettings}
          className="w-full rounded-[10px] py-4"
        >
          <span className="flex items-center justify-center gap-2">
            {t('profileCompletion.goToSettings')}
            <ArrowRight className="h-5 w-5" />
          </span>
        </Button>
      </motion.div>
    </div>
  );
};

export default CompleteProfileModalDesktop;
